"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var MODULE_NAME = 'authentication';
var SCRIPT_FILENAME = 'keepaliveworker.js';
var WorkerInit = /*#__PURE__*/function () {
  function WorkerInit() {
    var _this = this;
    (0, _classCallCheck2["default"])(this, WorkerInit);
    var handlers = {
      setItem: function setItem(key, value) {
        localStorage.setItem(key, value);
      },
      getItem: function getItem(key) {
        return localStorage.getItem(key);
      },
      removeItem: function removeItem(key) {
        return localStorage.removeItem(key);
      },
      getCallbackUrl: function getCallbackUrl() {
        return window.location.pathname;
      }
    };
    this.worker = new Worker(WorkerInit.buildPath());
    this.worker.onmessage = function (e) {
      var _e$data = e.data,
        type = _e$data.type,
        id = _e$data.id,
        args = _e$data.args,
        url = _e$data.url;
      var handler = handlers[type];
      if (handler) {
        var data = handler.apply(void 0, (0, _toConsumableArray2["default"])(args || []));
        _this.worker.postMessage({
          id: id,
          data: data
        });
      } else {
        _this.worker.postMessage({
          id: id
        });
      }
      if (type === 'redirectToAuthorize') {
        window.location.replace(url);
      }
    };
  }
  return (0, _createClass2["default"])(WorkerInit, null, [{
    key: "findScript",
    value: function findScript() {
      return document.querySelector("script[src^=\"/".concat(MODULE_NAME, "\"]"));
    }
  }, {
    key: "buildPath",
    value: function buildPath() {
      var script = WorkerInit.findScript();
      var src = script.getAttribute('src');
      //return [...src.split('/').slice(0, -1), SCRIPT_FILENAME].join('/');
      return src.replace('keepalive', 'keepaliveworker');
    }
  }]);
}();
lm.DOMReady(function () {
  if (window.KEEP_ALIVE_STATUS === 'CUSTOMER') {
    new WorkerInit();
  }
});